import { Children, ReactElement, ReactNode } from 'react'
import { overflowCountChip } from 'app/components/table/cellInteraction'

/** Invisible single-line row that renders the complete chip set for measurement.
 *  Absolutely positioned (the container must be `relative`), inert, and hidden. */
export function ChipMeasureRow({
  measureRef,
  children,
}: {
  measureRef: React.RefObject<HTMLDivElement | null>
  children: ReactNode
}): ReactElement {
  return (
    <div
      ref={measureRef}
      aria-hidden
      // Marked so column auto-fit can find it: this row is the only place the full
      // chip set exists, and being absolute it contributes nothing to the cell's
      // intrinsic width, so a fit measured without it could never widen the column
      // enough to reveal hidden chips.
      data-chip-measure-row=""
      className="pointer-events-none invisible absolute left-0 top-0 flex h-full items-center gap-1 whitespace-nowrap"
    >
      {children}
      {/* Absolute so the row's own width, which column auto-fit reads, stays the chips alone.
          "+total" is the widest the badge can get, so the reservation never falls short. The
          text is CSS-generated so text queries never find a second copy of the real "+N". */}
      <span
        data-overflow-badge={`+${Children.count(children)}`}
        className={`${overflowCountChip} absolute before:content-[attr(data-overflow-badge)]`}
      />
    </div>
  )
}
